import React, { useEffect, useState } from "react";
import Select from "react-select";
import {GENERIC_PAGINATED_KEY_VALUE_LIST, getApiPath} from "../../../api/ApiConst";
import apiCaller from "../../../api/ApiCaller";

const CollectionObjectListDropdown = ({ field = [], name, value, onChange }) => {
  const [optionList, setOptionList] = useState([]);

  let selectedOption =[]
  if(Array.isArray(value)){
    selectedOption = value.map((item) => ({label: item.name, value: item.id}))
  }else{
    selectedOption = []
  }

  useEffect(() => {
    const keyAttribute = field?.keyValuePair?.keyAttribute;
    const valueAttribute = field?.keyValuePair?.valueAttribute;
    if (!keyAttribute || !valueAttribute) return;

    const tableUrl = getApiPath(field.referenceTablePath, GENERIC_PAGINATED_KEY_VALUE_LIST);
    const payload = {
      page: 0,
      size: 200,
      searchFilters: [],
      sortRules: [],
      keyAttribute,
      valueAttribute,
    };

    apiCaller.callPostApi(
      tableUrl,
      payload,
      {},
      (response) => {
        const data = response?.data;
        setOptionList(
          Array.isArray(data)
            ? data.map((pair) => ({ label: pair.value, value: pair.key }))
            : []
        );
      },
      (error) => {
        console.error("error");
      }
    );
  }, []);

  return (
    <>
      <Select
        isMulti={true}
        name={name}
        value={selectedOption}
        options={optionList}
        onChange={(event) =>
          onChange({
            target: { name, value: event },
          })
        }
        className="react-select-container"
      />
    </>
  );
};

export default CollectionObjectListDropdown;
